import React from "react";
import { ReactComponent as LogoIcon } from '../../assets/icons/footer_logo.svg';
import { ReactComponent as FCBKIcon } from '../../assets/icons/fcbk.svg';
import { ReactComponent as TelegramIcon } from '../../assets/icons/telegram_bot.svg';
import moment from "moment";
import s from "./footer.module.scss";

const Footer = (props) => {

    const setMenu = (selected) => {
        props.setMenuActive(selected);
    }

    return (
        <div className={s.Footer}>
            <div className={s.FooterBlock}>
                <div className={s.icon}><LogoIcon /></div>
                <div className={s.footerButtons}>
                    <button onClick={setMenu.bind(this, 'OFFERT')}>{props.getValue('OFFERT')}</button>
                    <button onClick={setMenu.bind(this, 'PRIVACY_POLICY')}>{props.getValue('PRIVACY_POLICY_2')}</button>
                    <a className={s.mailto} href="mailto:echo@1cb.kz"><button>echo@1cb.kz</button></a>
                    <a href="https://t.me/joinchat/AAAAAEeRlKOBboDwly7h8A" target={'_blank'}><button><TelegramIcon /><span>{props.getValue('TELEGRAM_BOT')}</span></button></a>
                </div>
                <div className={s.icon+" "+s.secondIcon}><FCBKIcon /></div>
            </div>
            <div className={s.bottomBlock}>
                <span>© {props.getValue('FCBK')}. {moment().format("YYYY")}</span>
            </div>
        </div>
    )
}

export default Footer;